// extracted by mini-css-extract-plugin
export default {"full":"LoadingScreen_full__Qo4Q4","container":"LoadingScreen_container__p2j7L","text":"LoadingScreen_text__MNhlH","svg":"LoadingScreen_svg__UdJif"};